import { Stage } from "@amzn/uxm-stencil-react-components/lib/src/types";
import { OrderingConfig, SiteConfiguration } from "configuration/site-configuration";

export const SANDBOX = "sandbox";
export const DEV = "dev";
export const BETA = "beta";
export const GAMMA = "gamma";
export const PROD = "prod";
export const PERSONAL = "personal";
export const BASE_DOMAIN = "shop.it.a2z.com";

export class PERMISSIONS {
  // eslint-disable-next-line no-unused-vars
  public static BRAVE_HEART = "braveheart";
  // eslint-disable-next-line no-unused-vars
  public static USE_V2 = "v2";
  // eslint-disable-next-line no-unused-vars
  public static SOFTWARE_PROCUREMENT = "software_procurement";
  // eslint-disable-next-line no-unused-vars
  public static USE_HARDWARE_SHOP = "hardwareSHOP";
  // eslint-disable-next-line no-unused-vars
  public static USE_SUPPORT_PHASE_2 = "supportV2";
  // eslint-disable-next-line no-unused-vars
  public static TOGGLE_AIFORME_TAGS = "aiformeTags";
  // eslint-disable-next-line no-unused-vars
  public static TOGGLE_NEW_PDP = "toggleNewPdp";
  // eslint-disable-next-line no-unused-vars
  public static USE_SMART_RECS = "toggleSmartRecs";
  // eslint-disable-next-line no-unused-vars
  public static AI_FOR_ME = "aiforme";
  public static TOGGLE_SEARCH_EXPERIENCE = "toggleSearchExperience";
  public static TOGGLE_MY_AI_TOOLS = "toggleMyAiTools";
  public static TOGGLE_AIFORME_SEMANTIC_SEARCH = "toggleAiformeSemanticSearch";
  public static TOGGLE_HIGHLIGHT_PRODUCTS = "highlightProducts";
  public static TOGGLE_LISTS = "toggleLists";
  public static CATALOGICAL = "catalogical";
  public static TOGGLE_AUTO_GEN_FORMATTED_DESCRIPTION = "toggleAutoGenFormattedDescription";
  public static AIFORME_ADMIN_LISTS = "AiForMeListsAdmin";
  public static TOGGLE_COMPLIANCE_INFORMATION = "toggleComplianceInformation";
  public static TOGGLE_AI_FOR_ME_USECASES = "toggleAiForMeUseCases";
  public static TOGGLE_AI_FOR_ME_REVIEWS = "toggleAiForMeReviews";
  public static TOGGLE_SOFTWARE_REVIEWS = "toggleSoftwareReviews";
  public static TOGGLE_USE_INTENT = "toggleUseIntent";
  public static TOGGLE_AI_FOR_ME_LANDING_PAGE = "toggleAiForMeLandingPage";
  public static TOGGLE_SHOW_NON_VENDABLE = "toggleShowNonVendable";
  public static TOGGLE_HARDWARE_ORDER_CANCELLATION = "toggleHardwareOrderCancellation";
}

export interface MaintenanceSettings {
  enabled?: boolean;
}

export function getStage(baseDomain: string): string | undefined {
  if (BASE_DOMAIN === baseDomain) return PROD;
  else if (`${GAMMA}.${BASE_DOMAIN}` === baseDomain) return GAMMA;
  else if (`${BETA}.${BASE_DOMAIN}` === baseDomain) return BETA;
  else if (`${DEV}.${BASE_DOMAIN}` === baseDomain) return DEV;
  else if (`${SANDBOX}.${BASE_DOMAIN}` === baseDomain) return SANDBOX;
  else if (baseDomain.endsWith(`.personal.${BASE_DOMAIN}`)) return PERSONAL;

  return;
}

/**
 * Gets a configuration value depending on the environment stage.
 */
export function getConfigByEnv(): SiteConfiguration {
  const stage = getStage(location.hostname.replace("alt.", ""));
  switch (stage) {
    case PROD:
      return require(`configuration/config.prod.json`);
    case GAMMA:
      return require(`configuration/config.gamma.json`);
    case BETA:
      return require(`configuration/config.beta.json`);
    case DEV:
      return require(`configuration/config.dev.json`);
    case SANDBOX:
      return require(`configuration/config.sandbox.json`);
    case PERSONAL:
      return require(`configuration/config.personal.json`);
    default:
      return require(`configuration/config.local.json`);
  }
}

/**
 * Method to determine the UXM stage to use
 * @returns Uxm stage value
 */
export function getUxmStage(): Stage {
  const stage = getStage(location.hostname.replace("alt.", ""));
  switch (stage) {
    case PROD:
      return "prod";
    case GAMMA:
      return "gamma";
    default:
      return "beta";
  }
}

export const config = getConfigByEnv();
export const API_BASE_URL = config.apiBaseUrl;
export const ITMP_V2_ADMIN_URL = config.v2AdminUrl;
export const CATALOG_SERVICE_ENDPOINT = config.catalogServiceEndpoint;
export const CATALOGICAL_ENDPOINT = config.apiBaseUrl;
export const LOCATIONS_ENDPOINT = config.apiBaseUrl + "/locations";
export const ORDERING_CONFIG: OrderingConfig = config.ordering;
export const DEFAULT_SERVICE_REGION = config.region;
export const USE_MY_ASSETS = config.useMyAssets || false;
export const HOP_URL = config.hopUrl;
export const COUPA_URL = config.coupaUrl;
export const AMAZON_APPROVALS_URL = config.amazonApprovalsUrl;

export const IS_MAINTENANCE_MODE_ENABLED = process.env.ENABLE_MAINTENANCE_MODE === "true" || false;

/**
 * Order statuses to export
 */
export const EXPORTABLE_STATUSES = ["ready-for-export"];

function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts && parts.length === 2) return parts.pop()?.split(";").shift();
}

// Disallow letters in phone number fields
export const GENERAL_PHONE_NUMBER_REGEX = /^[^a-zA-Z]*\d+[^a-zA-Z]*$/;
